module.exports = __webpack_public_path__ + "static/media/answer-wrong.a63b7067.png";